<div class="p-2">
    <h4 mat-dialog-title>{{data.title}}</h4>

    <div mat-dialog-content>
        <p *ngFor="let msg of data.message" class="mb-2">{{msg}}</p>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-stroked-button type="button" (click)="close()" *ngIf="data.btnCancelText">{{data.btnCancelText}}</button>
        <button mat-flat-button type="button" [color]="data.btnOkColor || 'primary'" (click)="confirm()" *ngIf="!data.btnOkHidden">{{data.btnOkText}}</button>
    </div>
</div>